// src/icons/SemiCircleOverlap.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function SemiCircleOverlap() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 31 34",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0472 14.9699C9.50375 14.4264 9.50375 13.5452 10.0472 13.0017C14.8217 8.22728 22.5626 8.22728 27.3371 13.0017C32.1115 17.7762 32.1115 25.5171 27.3371 30.2916C22.5626 35.066 14.8217 35.066 10.0472 30.2916C9.50375 29.7481 9.50375 28.8669 10.0472 28.3234C10.5907 27.7799 11.4719 27.7799 12.0154 28.3234C15.7029 32.0109 21.6815 32.0109 25.3689 28.3234C29.0564 24.6359 29.0564 18.6574 25.3689 14.9699C21.6815 11.2824 15.7029 11.2824 12.0154 14.9699C11.4719 15.5134 10.5907 15.5134 10.0472 14.9699Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.9351 18.9665C21.4786 19.51 21.4786 20.3912 20.9351 20.9347C16.1607 25.7091 8.41976 25.7091 3.6453 20.9347C-1.12916 16.1602 -1.12916 8.41927 3.6453 3.64481C8.41976 -1.12965 16.1607 -1.12965 20.9351 3.64481C21.4786 4.1883 21.4786 5.06948 20.9351 5.61297C20.3916 6.15647 19.5105 6.15647 18.967 5.61297C15.2795 1.9255 9.30093 1.9255 5.61346 5.61297C1.92599 9.30044 1.92599 15.279 5.61346 18.9665C9.30093 22.654 15.2795 22.654 18.967 18.9665C19.5105 18.423 20.3916 18.423 20.9351 18.9665Z",
            fill: "#00AD54"
          }
        )
      ]
    }
  );
}

export {
  SemiCircleOverlap
};
